import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'font-awesome/css/font-awesome.css';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import './styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import App from './containers/App';
import reducers from './reducers';

// Google Tag manager
import TagManager from 'react-gtm-module';

// Required for clockpicker (not by preference...)
import $ from 'jquery';
window.jQuery = $;
require('bootstrap/dist/js/bootstrap.min.js');
require('clockpicker/dist/bootstrap-clockpicker.css');
require('clockpicker/dist/bootstrap-clockpicker.js');
require('clockpicker/dist/jquery-clockpicker.css');
require('clockpicker/dist/jquery-clockpicker.js');

// polyfill stuff for older browsers. Might want to be more specific than this at some point.
require('core-js');

const tagManagerArgs = {
  gtmId: 'GTM-PC8TZH'
};

TagManager.initialize(tagManagerArgs);

const store = createStore(
  reducers,
  {},
  compose(
    applyMiddleware(reduxThunk), // middleware
    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f
  )
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/index.js